<template>
    <transition name="fade">
        <div v-if="show" class="callout text-left">
            <div class="arrow"></div>
            <div class="callout-outer p-3 basic-shadow arrow-top">
                <div class="dropdown-filler"></div>
                <div class="callout-content d-block">
                    <slot></slot>
                </div>
                <div class="d-block mt-2 float-right">
                    <a @click="dismiss" style="color: white;font-size: 14px;" class="text-right">Dismiss</a>
                </div>
            </div>
        </div>
    </transition>
</template>


<script>
    export default {
        name: 'callout',
        data: function () {
            return {
                dismissedCalloutList: this.$cookies.isKey('callouts') ? JSON.parse(this.$cookies.get('callouts')) : []
            }
        },
        props: {
            pos: {
                type: String,
                default: ''
            },
            id: {
                type: String,
                required: true
            },
        },
        methods: {
            dismiss() {
                this.dismissedCalloutList.push(this.id);
                this.$cookies.set('callouts', JSON.stringify(this.dismissedCalloutList), "30D");
            }
        },
        computed: {
            show() {
                return !this.dismissedCalloutList.includes(this.id);
            }
        }
    }
</script>
<style lang="scss" scoped>

    @import "~@shared/_assets/scss/constants";

    .callout {
        z-index: 500;
        white-space: normal;
        font-weight: normal;

        .callout-content {

            display: block;
            width: 300px;
        }

        .dropdown-button {
            position: relative;
        }

        .arrow {
            position: absolute;
            display: block;
            left: 50%;
            width: auto;
            -webkit-transform: translateX(-50%);
            transform: translateX(-50%);
            top: 40px;

            &:before {
                margin-left: -6px;
                content: '';
                display: block;
                position: absolute;
                bottom: 100%;
                width: 0;
                height: 0;
                border: 6px solid transparent;
                border-bottom-color: $color-primary;
            }
        }

        .callout-outer {
            background: $color-primary;
            position: absolute;
            cursor: default;
            color: white;
            right: 0;
            z-index: 999;
            margin-top: 11px;
        }
    }


</style>
